module.exports = __webpack_public_path__ + "img/6f1d39e.png";